import global from '../general/global';

export default {
    initializeSwiper: function () {
        let infoSwiper;

        if(jQuery(window).width() < 1024) {
            jQuery('.js-info--swiper').addClass('swiper');
            jQuery('.js-info--swiper-wrapper').addClass('swiper-wrapper');
            jQuery('.js-info--swiper-slide').addClass('swiper-slide');

            if (!global.swiperLoaded) {
                loadjs([menaObject.assets + '/js/swiper.min.js', menaObject.assets + '/css/swiper.css'], function () {
                    infoSwiper = new Swiper('.js-info--swiper', {
                        slidesPerView: 1,
                        navigation: {
                            nextEl: '.js-info--swiper-next',
                            prevEl: '.js-info--swiper-prev',
                        },
                    });
    
                    global.swiperLoaded = true;
                });
            } else {
                infoSwiper = new Swiper('.js-info--swiper', {
                    slidesPerView: 1,
                    navigation: {
                        nextEl: '.js-info--swiper-next',
                        prevEl: '.js-info--swiper-prev',
                    },
                });
            }
        }
    },
};
